import { useEffect, useState } from "react";
import * as Mui from "@mui/material";
import * as MuiIcons from "@mui/icons-material";
import { CategoriesSelect } from "components";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import YoutubeVideoEkle from "./YoutubeVideoEkle";
import Fotograflar from "./Fotograflar";
import { useGetImagesMutation } from "api/editorImages";

const DetailForm = ({
  id,
  youtube,
  setYoutube,
  images,
  imagesState,
  setImagesState,
  onChangeImages,
  setImages,
  handleSubmit,
  token,
  handleChangeEditor,
  setToken,
  ...props
}) => {
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [GetImages, getImagesData] = useGetImagesMutation();
  const [articleImages, setArticleImages] = useState([]);
  const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);

  const handleModal = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleModal2 = () => {
    setOpen2(true);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  const handleAddPhotos = () => {
    if (currentPhotoIndex < articleImages.length) {
      const paragraphs = props.content.split("</p>");
      const newParagraphs = paragraphs.map((paragraph, index) => {
        if (index === currentPhotoIndex) {
          const imgTag = `<img src="${articleImages[currentPhotoIndex].images}" alt=""/>`;
          return `${paragraph}${imgTag}`;
        }
        return paragraph;
      });

      const updatedHtml = newParagraphs.join("</p>");
      handleChangeEditor(updatedHtml);
      setCurrentPhotoIndex(currentPhotoIndex + 1);
    }
  };

  useEffect(() => {
    GetImages({ token });
  }, [GetImages, token]);

  useEffect(() => {
    if (getImagesData.isSuccess) {
      setArticleImages(getImagesData.data);
    }
  }, [getImagesData]);

  return (
    <Mui.Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
      <div className="grid grid-cols-1 gap-6">
        <Mui.FormControl fullWidth>
          <Mui.TextField
            sx={{ m: 0 }}
            size="small"
            margin="normal"
            required
            fullWidth
            id="title"
            label="Başlık"
            name="title"
            autoComplete="title"
            onChange={props.handleChange}
            defaultValue={props.initialValues.title}
            key={props.initialValues.title}
            values={props.values.title}
            helperText={props.errors.title && props.errors.title}
            error={props.errors.title ? true : false}
          />
        </Mui.FormControl>
        <Mui.FormControl fullWidth>
          {props.categories.isLoading ? (
            <Mui.Skeleton height={45} />
          ) : (
            <CategoriesSelect
              data={props.categories}
              urunKategori={props.urunKategori}
              handleOnChange={props.handleOnChange}
            />
          )}
        </Mui.FormControl>
        <Mui.FormControl fullWidth>
          <div className="w-full flex items-center gap-5">
            <Mui.Button
              startIcon={<MuiIcons.Subscriptions />}
              variant="contained"
              color="error"
              size="small"
              lang="tr"
              fullWidth
              onClick={handleModal}
            >
              YouTube Videosu
            </Mui.Button>
            <Mui.Button
              startIcon={<MuiIcons.PhotoLibrary />}
              variant="contained"
              color="info"
              size="small"
              lang="tr"
              fullWidth
              onClick={handleModal2}
            >
              Fotoğraflar
            </Mui.Button>
            <Mui.Button
              startIcon={<MuiIcons.ChecklistRtl />}
              variant="contained"
              color="success"
              size="small"
              lang="tr"
              fullWidth
              onClick={handleAddPhotos}
              disabled={images.length > 0 ? false : true}
            >
              Fotoğrafları Yazıya Ekle
            </Mui.Button>
          </div>
        </Mui.FormControl>
        <Mui.FormControl fullWidth>
          <ReactQuill
            value={props.content}
            onChange={handleChangeEditor}
            theme={"snow"}
            modules={{
              toolbar: [
                // Diğer araç çubuğu öğelerini ekleyin
                [{ header: "1" }, { header: "2" }, { font: [] }],
                [{ list: "ordered" }, { list: "bullet" }],
                ["link", "image", "video"],
                ["clean", "code"],
              ],
              // Paragraf sonlarına otomatik olarak fotoğraf ekleme işlevselliği
              clipboard: {
                matchVisual: false,
              },
            }}
          />
        </Mui.FormControl>
      </div>
      <div className="w-full flex justify-end gap-4 mt-16">
        <Mui.FormControl>
          <Mui.Button
            startIcon={<MuiIcons.ArrowBack />}
            size="small"
            type="button"
            href="/articles"
            fullWidth
            variant="contained"
            lang={"tr"}
          >
            Geri Dön
          </Mui.Button>
        </Mui.FormControl>
        <Mui.FormControl>
          <Mui.Button
            startIcon={<MuiIcons.CheckCircle />}
            size="small"
            type="submit"
            fullWidth
            variant="contained"
            lang={"tr"}
          >
            Kaydet
          </Mui.Button>
        </Mui.FormControl>
        <YoutubeVideoEkle
          id="videoEkleme"
          keepMounted
          open={open}
          onClose={handleClose}
          youtube={youtube}
          setYoutube={setYoutube}
        />
        <Fotograflar
          id="fotoEkleme"
          keepMounted
          articleId={id}
          open={open2}
          onClose={handleClose2}
          images={images}
          onChangeImages={onChangeImages}
          imagesState={imagesState}
          setImagesState={setImagesState}
          setImages={setImages}
          token={token}
          setToken={setToken}
        />
      </div>
    </Mui.Box>
  );
};

export default DetailForm;
